import { useState } from 'react';
import { isHungryrootAppUserAgent } from '../utils/isHungryrootAppUserAgent';

export function useIsEmbeddedWebView() {
  // we only need to calculate this once
  const [isEmbedded] = useState(() =>
    isHungryrootAppUserAgent(navigator.userAgent)
  );
  return isEmbedded;
}
